import { styled } from "@mui/material";
import { get } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { user_role_type_display_name } from "../auth/constants";
import { us_states_options } from "../utils/constants";
import utilOperations from "../utils/operations";

const StyledContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "row",
    gap: "1vw",
    "@media (max-width: 1280px)": {
        flexDirection: "column",
    },
}));

const UserAccountDetail = (props) => {
    const { userAccount, errors, handleInputChange } = props;

    return (
        <div>
            <StyledContainer style={{ display: "flex", gap: "1vw" }}>
                <BSInput
                    id="firstName"
                    label="FIRST NAME"
                    value={get(userAccount, "person.firstName", null)}
                    disabled={true}
                />
                <BSInput
                    id="lastName"
                    label="LAST NAME"
                    value={get(userAccount, "person.lastName", null)}
                    disabled={true}
                />
                <BSInput id="email" label="EMAIL" value={get(userAccount, "email", null)} disabled={true} />
                <BSInput
                    id="department"
                    label="DEPARTMENT"
                    value={get(userAccount, "department", null)}
                    disabled={true}
                />
            </StyledContainer>
            <StyledContainer>
                <BSInput id="title" label="TITLE" value={get(userAccount, "title", null)} disabled={true} />
                <BSInput
                    id="speciality"
                    label="SPECIALITY"
                    value={get(userAccount, "speciality", null)}
                    disabled={true}
                />
                <BSInput
                    id="primaryPhoneNumber"
                    label="DIRECT PHONE"
                    value={get(userAccount, "primaryPhoneNumber", null)}
                    disabled={true}
                    phone={true}
                />
                <BSInput
                    id="secondaryPhoneNumber"
                    label="MOBILE PHONE"
                    value={get(userAccount, "secondaryPhoneNumber", null)}
                    disabled={true}
                    phone={true}
                />
            </StyledContainer>
            <StyledContainer style={{ display: "flex", gap: "1vw" }}>
                <BSInput
                    id="address"
                    label="ADDRESS"
                    value={get(userAccount, "person.address.address1", null)}
                    disabled={true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                />
                <div style={{ display: "flex", gap: "1vw", flex: "1 1 0" }}>
                    <BSInput
                        id="city"
                        label="CITY"
                        value={get(userAccount, "person.address.city.city", null)}
                        disabled={true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                    <BSSelect
                        id="stateCode"
                        label="STATE"
                        value={get(userAccount, "person.address.city.state.stateCode", null)}
                        options={us_states_options}
                        disabled={true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                    <BSInput
                        id="zipCode"
                        label="ZIP CODE"
                        value={get(userAccount, "person.address.zipCode.zipCode", null)}
                        disabled={true}
                        extraFormControlStyles={{ flex: "1 1 0" }}
                    />
                </div>
            </StyledContainer>
            <StyledContainer>
                <BSInput
                    id="office"
                    label="OFFICE"
                    value={get(userAccount, "office.officeName", null)}
                    disabled={true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                />
                <BSSelect
                    id="role"
                    label="USER TYPE"
                    value={get(userAccount, "role", null)}
                    error={errors.role}
                    options={utilOperations.keyValueOptionsBuilder(user_role_type_display_name)}
                    onChange={(e) => handleInputChange("userAccount.role", e.target.value)}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                />
            </StyledContainer>
        </div>
    );
};

export default UserAccountDetail;
